import { TabbedGroup } from "../../../components/TabbedGroup";
import { AdminPermissions as AP } from "../../../lib/data";
import Missions from "../Missions";
import Campaigns from "../Campaigns";
import Announcements from "../Announcements";

export default function Content() {
  return (
    <TabbedGroup
      tabs={[
        { value: "activities", label: "Activities", permission: AP.MANAGE_MISSIONS, element: <Missions /> },
        { value: "campaigns", label: "Campaigns", permission: AP.MANAGE_MISSIONS, element: <Campaigns /> },
        { value: "announcements", label: "Announcements", permission: AP.MANAGE_MISSIONS, element: <Announcements /> },
      ]}
    />
  );
}
